<template>
    <v-app id="app">


        <main>

            <router-view></router-view>


        </main>
        <!--
        <v-footer style="text-align: center"><div style="width: 100%">{{$store.state.rechnerConfig.rechnerInfo.label}}</div></v-footer>
        -->

    </v-app>

</template>
<!-- _____________________________________________________________________________________________________________________________________________________________ -->
<!-- ############################################################################################################################################################# -->
<script>
  // import Vue from 'vue'
  //import CryptoJS from 'Crypto-JS'

  export default {
    data: function () {
      return {decoded: 'neeee'}
    },
    name: 'app',
    methods: {
      decrypt: function () {
      /*
        var passphrase = "eec7cdc54bcd87fa8eab72b02ae9ae92";
        // var encrypted_json_string = "";
        //var obj_json = JSON.parse(encrypted_json_string);
        var obj_json = {
          "ciphertext": "4Lsft+NEZfh2GyoKS768/cdtv0SmKE6Wu04HWQXXoxo=",
          "iv": "cb7cc150e96843fe335681b6ea24191b",
          "salt": "a2e47d25428b9ba39782307cd5b105a2abb0f054017c6409e4bb8ff0d6a10d4e540cc4260a790d288f8d8588303e73c0a5918f12bc8dc13a6b086726fe43bd894a87b57e73f53f7fd78e559fe8d14b38fd58b19077acec980f51d6ec028bf75fc0e509c7e078d4df0ada14c2ee596a7356dcae84ffb0723f4f8e0da4c93769bf86a6190c0b841cbd09844853631b3d7b670280620b85cd160aa7f6b221f629b65580599638b7a5f783fbfa6439fd247dc6e8f5c547414a212ed7f355e2c0573bab2830e23ed648bdcbbd2edf7aa5fa79948be615230b22b183aefd6085de29dd83740dda0d56fdfcfb4d6a983bd0626bc393b928037dad09a2a7951820eb4935"
        }

        obj_json = {
          "ciphertext": "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",
          "iv": "a0537f5769ed861b8e4939746e952a26",
          "salt": "8a2b468e8a1ca5eb97936d8a4a8df28074a5c1a56d16c06e74bbbc220bc564736a90e62eeb206aad83284a7cb226353ec9c514593f1bdd635976e385d08ff2613813eac6ad683a6df78d4ebeafe41a86a6d8ca3a951931e52e374d80f39840bcd91e9f7660edf4e143a34a576fc55bb8d908231441d24daa36b9282e628c075aca3005fa1ef42a10e616fb4d71008dfaf94c7c77d85b33896b9f5d1196aeadeee59bd26ab81bd03273de25d1ed0dea38f115d3f15da515c5088f4ede4a5d96b6957e11951a10f4e1885a128907faf3565d80db6fe6b9dc403c94d893cb369ebcd179fe0a4a409bd2010b623f54d8737b8992262622b69ea3ffda073584f19bd7"
        }



        var encrypted = obj_json.ciphertext;
        var salt = CryptoJS.enc.Hex.parse(obj_json.salt);
        var iv = CryptoJS.enc.Hex.parse(obj_json.iv);

        var key = CryptoJS.PBKDF2(passphrase, salt, {hasher: CryptoJS.algo.SHA512, keySize: 64 / 8, iterations: 999});


        var decrypted = CryptoJS.AES.decrypt(encrypted, key, {iv: iv});

        var result = decrypted.toString(CryptoJS.enc.Utf8);
        console.log("XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX")
        console.log(JSON.parse(result))
        console.log("XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX")

        return "oki";



        //encrrypt:
     var keyBitLength = 256;
    var ivBitLength = 128;
    var iterations = 234;

    var salt = CryptoJS.lib.WordArray.random(256 / 8);

    var iv128Bits = CryptoJS.PBKDF2(password, salt, { keySize: 128 / 32, iterations: iterations });
    var key256Bits = CryptoJS.PBKDF2(password, salt, { keySize: 256 / 32, iterations: iterations });

    var data = CryptoJS.AES.encrypt(message, key256Bits, { iv: iv128Bits }); // , format: JsonFormatter















        */
      },


    },
  }
</script>

<!-- ############################################################################################################################################################# -->
<!-- ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯ -->
<style lang="stylus">
    @import '../../node_modules/vuetify/src/stylus/settings/_colors'

    $theme :={
        primary: #1487BE
        accent: #779bd7
        secondary: $grey.darken-3
        info: #1d5a98
        warning: $amber.base
        error: $red.base
        success: $green.base
    }

    @import '../../node_modules/vuetify/src/stylus/main'


    @import '../css/main.css'

</style>


<style>

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        margin-top: 0px;
    }

    h1,h2,h3,h4,h5,h6{
        text-align: center;
    }

    .flex{
        text-align: left;
    }

/*
    @charset "UTF-8";
    /
    /
    vue2-animate v1

    .0
    .4

    @keyframes bounceIn {
        from,
        20%,
        40%,
        60%,
        80%,
        to {
            animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
        }
        0% {
            opacity: 0;
            transform: scale3d(0.3, 0.3, 0.3);
        }
        20% {
            transform: scale3d(1.1, 1.1, 1.1);
        }
        40% {
            transform: scale3d(0.9, 0.9, 0.9);
        }
        60% {
            opacity: 1;
            transform: scale3d(1.03, 1.03, 1.03);
        }
        80% {
            transform: scale3d(0.97, 0.97, 0.97);
        }
        to {
            opacity: 1;
            transform: scale3d(1, 1, 1);
        }
    }

    @keyframes bounceOut {
        20% {
            transform: scale3d(0.9, 0.9, 0.9);
        }
        50%,
        55% {
            opacity: 1;
            transform: scale3d(1.1, 1.1, 1.1);
        }
        to {
            opacity: 0;
            transform: scale3d(0.3, 0.3, 0.3);
        }
    }

    @keyframes bounceInDown {
        from,
        60%,
        75%,
        90%,
        to {
            animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
        }
        0% {
            opacity: 0;
            transform: translate3d(0, -3000px, 0);
        }
        60% {
            opacity: 1;
            transform: translate3d(0, 25px, 0);
        }
        75% {
            transform: translate3d(0, -10px, 0);
        }
        90% {
            transform: translate3d(0, 5px, 0);
        }
        to {
            transform: none;
        }
    }

    @keyframes bounceOutDown {
        20% {
            transform: translate3d(0, 10px, 0);
        }
        40%,
        45% {
            opacity: 1;
            transform: translate3d(0, -20px, 0);
        }
        to {
            opacity: 0;
            transform: translate3d(0, 2000px, 0);
        }
    }

    @keyframes bounceInLeft {
        from,
        60%,
        75%,
        90%,
        to {
            animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
        }
        0% {
            opacity: 0;
            transform: translate3d(-3000px, 0, 0);
        }
        60% {
            opacity: 1;
            transform: translate3d(25px, 0, 0);
        }
        75% {
            transform: translate3d(-10px, 0, 0);
        }
        90% {
            transform: translate3d(5px, 0, 0);
        }
        to {
            transform: none;
        }
    }

    @keyframes bounceOutLeft {
        20% {
            opacity: 1;
            transform: translate3d(20px, 0, 0);
        }
        to {
            opacity: 0;
            transform: translate3d(-2000px, 0, 0);
        }
    }

    @keyframes bounceInRight {
        from,
        60%,
        75%,
        90%,
        to {
            animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
        }
        from {
            opacity: 0;
            transform: translate3d(3000px, 0, 0);
        }
        60% {
            opacity: 1;
            transform: translate3d(-25px, 0, 0);
        }
        75% {
            transform: translate3d(10px, 0, 0);
        }
        90% {
            transform: translate3d(-5px, 0, 0);
        }
        to {
            transform: none;
        }
    }

    @keyframes bounceOutRight {
        20% {
            opacity: 1;
            transform: translate3d(-20px, 0, 0);
        }
        to {
            opacity: 0;
            transform: translate3d(2000px, 0, 0);
        }
    }

    @keyframes bounceInUp {
        from,
        60%,
        75%,
        90%,
        to {
            animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
        }
        from {
            opacity: 0;
            transform: translate3d(0, 3000px, 0);
        }
        60% {
            opacity: 1;
            transform: translate3d(0, -20px, 0);
        }
        75% {
            transform: translate3d(0, 10px, 0);
        }
        90% {
            transform: translate3d(0, -5px, 0);
        }
        to {
            transform: translate3d(0, 0, 0);
        }
    }

    @keyframes bounceOutUp {
        20% {
            transform: translate3d(0, -10px, 0);
        }
        40%,
        45% {
            opacity: 1;
            transform: translate3d(0, 20px, 0);
        }
        to {
            opacity: 0;
            transform: translate3d(0, -2000px, 0);
        }
    }

    .bounce-enter-active,
    .bounceIn,
    .bounce-leave-active,
    .bounceOut {
        animation-duration: 1s;
        animation-fill-mode: both;
    }

    .bounce-enter-active,
    .bounceIn {
        animation-name: bounceIn;
    }

    .bounce-leave-active,
    .bounceOut {
        animation-name: bounceOut;
    }

    .bounceUp-enter-active,
    .bounceInUp,
    .bounceUp-leave-active,
    .bounceOutUp {
        animation-duration: 1s;
        animation-fill-mode: both;
    }

    .bounceUp-enter-active,
    .bounceInUp {
        animation-name: bounceInUp;
    }

    .bounceUp-leave-active,
    .bounceOutUp {
        animation-name: bounceOutUp;
    }

    .bounceRight-enter-active,
    .bounceInRight,
    .bounceRight-leave-active,
    .bounceOutRight {
        animation-duration: 1s;
        animation-fill-mode: both;
    }

    .bounceRight-enter-active,
    .bounceInRight {
        animation-name: bounceInRight;
    }

    .bounceRight-leave-active,
    .bounceOutRight {
        animation-name: bounceOutRight;
    }

    .bounceLeft-enter-active,
    .bounceInLeft,
    .bounceLeft-leave-active,
    .bounceOutLeft {
        animation-duration: 1s;
        animation-fill-mode: both;
    }

    .bounceLeft-enter-active,
    .bounceInLeft {
        animation-name: bounceInLeft;
    }

    .bounceLeft-leave-active,
    .bounceOutLeft {
        animation-name: bounceOutLeft;
    }

    .bounceDown-enter-active,
    .bounceInDown,
    .bounceDown-leave-active,
    .bounceOutDown {
        animation-duration: 1s;
        animation-fill-mode: both;
    }

    .bounceDown-enter-active,
    .bounceInDown {
        animation-name: bounceInDown;
    }

    .bounceDown-leave-active,
    .bounceOutDown {
        animation-name: bounceOutDown;
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }

    @keyframes fadeOut {
        from {
            opacity: 1;
        }
        to {
            opacity: 0;
        }
    }

    @keyframes fadeInDown {
        from {
            opacity: 0;
            transform: translate3d(0, -100%, 0);
        }
        to {
            opacity: 1;
            transform: none;
        }
    }

    @keyframes fadeOutDown {
        from {
            opacity: 1;
        }
        to {
            opacity: 0;
            transform: translate3d(0, 100%, 0);
        }
    }

    @keyframes fadeInDownBig {
        from {
            opacity: 0;
            transform: translate3d(0, -2000px, 0);
        }
        to {
            opacity: 1;
            transform: none;
        }
    }

    @keyframes fadeOutDownBig {
        from {
            opacity: 1;
        }
        to {
            opacity: 0;
            transform: translate3d(0, 2000px, 0);
        }
    }

    @keyframes fadeInLeft {
        from {
            opacity: 0;
            transform: translate3d(-100%, 0, 0);
        }
        to {
            opacity: 1;
            transform: none;
        }
    }

    @keyframes fadeOutLeft {
        from {
            opacity: 1;
        }
        to {
            opacity: 0;
            transform: translate3d(-100%, 0, 0);
        }
    }

    @keyframes fadeInLeftBig {
        from {
            opacity: 0;
            transform: translate3d(-2000px, 0, 0);
        }
        to {
            opacity: 1;
            transform: none;
        }
    }

    @keyframes fadeOutLeftBig {
        from {
            opacity: 1;
        }
        to {
            opacity: 0;
            transform: translate3d(-2000px, 0, 0);
        }
    }

    @keyframes fadeInRight {
        from {
            opacity: 0;
            transform: translate3d(100%, 0, 0);
        }
        to {
            opacity: 1;
            transform: none;
        }
    }

    @keyframes fadeOutRight {
        from {
            opacity: 1;
        }
        to {
            opacity: 0;
            transform: translate3d(100%, 0, 0);
        }
    }

    @keyframes fadeInRightBig {
        from {
            opacity: 0;
            transform: translate3d(2000px, 0, 0);
        }
        to {
            opacity: 1;
            transform: none;
        }
    }

    @keyframes fadeOutRightBig {
        from {
            opacity: 1;
        }
        to {
            opacity: 0;
            transform: translate3d(2000px, 0, 0);
        }
    }

    @keyframes fadeInUp {
        from {
            opacity: 0;
            transform: translate3d(0, 100%, 0);
        }
        to {
            opacity: 1;
            transform: none;
        }
    }

    @keyframes fadeOutUp {
        from {
            opacity: 1;
        }
        to {
            opacity: 0;
            transform: translate3d(0, -100%, 0);
        }
    }

    @keyframes fadeInUpBig {
        from {
            opacity: 0;
            transform: translate3d(0, 2000px, 0);
        }
        to {
            opacity: 1;
            transform: none;
        }
    }

    @keyframes fadeOutUp {
        from {
            opacity: 1;
        }
        to {
            opacity: 0;
            transform: translate3d(0, -100%, 0);
        }
    }

    .fade-enter-active,
    .fadeIn,
    .fade-leave-active,
    .fadeOut {
        animation-duration: 1s;
        animation-fill-mode: both;
    }

    .fade-enter-active,
    .fadeIn {
        animation-name: fadeIn;
    }

    .fade-leave-active,
    .fadeOut {
        animation-name: fadeOut;
    }

    .fadeUpBig-enter-active,
    .fadeInUpBig,
    .fadeUpBig-leave-active,
    .fadeOutUpBig {
        animation-duration: 1s;
        animation-fill-mode: both;
    }

    .fadeUpBig-enter-active,
    .fadeInUpBig {
        animation-name: fadeInUpBig;
    }

    .fadeUpBig-leave-active,
    .fadeOutUpBig {
        animation-name: fadeOutUpBig;
    }

    .fadeUp-enter-active,
    .fadeInUp,
    .fadeUp-leave-active,
    .fadeOutUp {
        animation-duration: 1s;
        animation-fill-mode: both;
    }

    .fadeUp-enter-active,
    .fadeInUp {
        animation-name: fadeInUp;
    }

    .fadeUp-leave-active,
    .fadeOutUp {
        animation-name: fadeOutUp;
    }

    .fadeRightBig-enter-active,
    .fadeInRightBig,
    .fadeRightBig-leave-active,
    .fadeOutRightBig {
        animation-duration: 1s;
        animation-fill-mode: both;
    }

    .fadeRightBig-enter-active,
    .fadeInRightBig {
        animation-name: fadeInRightBig;
    }

    .fadeRightBig-leave-active,
    .fadeOutRightBig {
        animation-name: fadeOutRightBig;
    }

    .fadeRight-enter-active,
    .fadeInRight,
    .fadeRight-leave-active,
    .fadeOutRight {
        animation-duration: 1s;
        animation-fill-mode: both;
    }

    .fadeRight-enter-active,
    .fadeInRight {
        animation-name: fadeInRight;
    }

    .fadeRight-leave-active,
    .fadeOutRight {
        animation-name: fadeOutRight;
    }

    .fadeLeftBig-enter-active,
    .fadeInLeftBig,
    .fadeLeftBig-leave-active,
    .fadeOutLeftBig {
        animation-duration: 1s;
        animation-fill-mode: both;
    }

    .fadeLeftBig-enter-active,
    .fadeInLeftBig {
        animation-name: fadeInLeftBig;
    }

    .fadeLeftBig-leave-active,
    .fadeOutLeftBig {
        animation-name: fadeOutLeftBig;
    }

    .fadeLeft-enter-active,
    .fadeInLeft,
    .fadeLeft-leave-active,
    .fadeOutLeft {
        animation-duration: 1s;
        animation-fill-mode: both;
    }

    .fadeLeft-enter-active,
    .fadeInLeft {
        animation-name: fadeInLeft;
    }

    .fadeLeft-leave-active,
    .fadeOutLeft {
        animation-name: fadeOutLeft;
    }

    .fadeDownBig-enter-active,
    .fadeInDownBig,
    .fadeDownBig-leave-active,
    .fadeOutDownBig {
        animation-duration: 1s;
        animation-fill-mode: both;
    }

    .fadeDownBig-enter-active,
    .fadeInDownBig {
        animation-name: fadeInDownBig;
    }

    .fadeDownBig-leave-active,
    .fadeOutDownBig {
        animation-name: fadeOutDownBig;
    }

    .fadeDown-enter-active,
    .fadeInDown,
    .fadeDown-leave-active,
    .fadeOutDown {
        animation-duration: 1s;
        animation-fill-mode: both;
    }

    .fadeDown-enter-active,
    .fadeInDown {
        animation-name: fadeInDown;
    }

    .fadeDown-leave-active,
    .fadeOutDown {
        animation-name: fadeOutDown;
    }

    @keyframes rotateIn {
        from {
            transform-origin: center;
            transform: rotate3d(0, 0, 1, -200deg);
            opacity: 0;
        }
        to {
            transform-origin: center;
            transform: none;
            opacity: 1;
        }
    }

    @keyframes rotateOut {
        from {
            transform-origin: center;
            opacity: 1;
        }
        to {
            transform-origin: center;
            transform: rotate3d(0, 0, 1, 200deg);
            opacity: 0;
        }
    }

    @keyframes rotateInDownLeft {
        from {
            transform-origin: left bottom;
            transform: rotate3d(0, 0, 1, -45deg);
            opacity: 0;
        }
        to {
            transform-origin: left bottom;
            transform: none;
            opacity: 1;
        }
    }

    @keyframes rotateOutDownLeft {
        from {
            transform-origin: left bottom;
            opacity: 1;
        }
        to {
            transform-origin: left bottom;
            transform: rotate3d(0, 0, 1, 45deg);
            opacity: 0;
        }
    }

    @keyframes rotateInDownRight {
        from {
            transform-origin: right bottom;
            transform: rotate3d(0, 0, 1, 45deg);
            opacity: 0;
        }
        to {
            transform-origin: right bottom;
            transform: none;
            opacity: 1;
        }
    }

    @keyframes rotateOutDownRight {
        from {
            transform-origin: right bottom;
            opacity: 1;
        }
        to {
            transform-origin: right bottom;
            transform: rotate3d(0, 0, 1, -45deg);
            opacity: 0;
        }
    }

    @keyframes rotateInUpLeft {
        from {
            transform-origin: left bottom;
            transform: rotate3d(0, 0, 1, 45deg);
            opacity: 0;
        }
        to {
            transform-origin: left bottom;
            transform: none;
            opacity: 1;
        }
    }

    @keyframes rotateOutUpLeft {
        from {
            transform-origin: left bottom;
            opacity: 1;
        }
        to {
            transform-origin: left bottom;
            transform: rotate3d(0, 0, 1, -45deg);
            opacity: 0;
        }
    }

    @keyframes rotateInUpRight {
        from {
            transform-origin: right bottom;
            transform: rotate3d(0, 0, 1, -90deg);
            opacity: 0;
        }
        to {
            transform-origin: right bottom;
            transform: none;
            opacity: 1;
        }
    }

    @keyframes rotateOutUpRight {
        from {
            transform-origin: right bottom;
            opacity: 1;
        }
        to {
            transform-origin: right bottom;
            transform: rotate3d(0, 0, 1, 90deg);
            opacity: 0;
        }
    }

    .rotate-enter-active,
    .rotateIn,
    .rotate-leave-active,
    .rotateOut {
        animation-duration: 1s;
        animation-fill-mode: both;
    }

    .rotate-enter-active,
    .rotateIn {
        animation-name: rotateIn;
    }

    .rotate-leave-active,
    .rotateOut {
        animation-name: rotateOut;
    }

    .rotateUpRight-enter-active,
    .rotateInUpRight,
    .rotateUpRight-leave-active,
    .rotateOutUpRight {
        animation-duration: 1s;
        animation-fill-mode: both;
    }

    .rotateUpRight-enter-active,
    .rotateInUpRight {
        animation-name: rotateInUpRight;
    }

    .rotateUpRight-leave-active,
    .rotateOutUpRight {
        animation-name: rotateOutUpRight;
    }

    .rotateUpLeft-enter-active,
    .rotateInUpLeft,
    .rotateUpLeft-leave-active,
    .rotateOutUpLeft {
        animation-duration: 1s;
        animation-fill-mode: both;
    }

    .rotateUpLeft-enter-active,
    .rotateInUpLeft {
        animation-name: rotateInUpLeft;
    }

    .rotateUpLeft-leave-active,
    .rotateOutUpLeft {
        animation-name: rotateOutUpLeft;
    }

    .rotateDownRight-enter-active,
    .rotateInDownRight,
    .rotateDownRight-leave-active,
    .rotateOutDownRight {
        animation-duration: 1s;
        animation-fill-mode: both;
    }

    .rotateDownRight-enter-active,
    .rotateInDownRight {
        animation-name: rotateInDownRight;
    }

    .rotateDownRight-leave-active,
    .rotateOutDownRight {
        animation-name: rotateOutDownRight;
    }

    .rotateDownLeft-enter-active,
    .rotateInDownLeft,
    .rotateDownLeft-leave-active,
    .rotateOutDownLeft {
        animation-duration: 1s;
        animation-fill-mode: both;
    }

    .rotateDownLeft-enter-active,
    .rotateInDownLeft {
        animation-name: rotateInDownLeft;
    }

    .rotateDownLeft-leave-active,
    .rotateOutDownLeft {
        animation-name: rotateOutDownLeft;
    }

    @keyframes slideInDown {
        from {
            transform: translate3d(0, -100%, 0);
            visibility: visible;
        }
        to {
            transform: translate3d(0, 0, 0);
        }
    }

    @keyframes slideOutDown {
        from {
            transform: translate3d(0, 0, 0);
        }
        to {
            visibility: hidden;
            transform: translate3d(0, 100%, 0);
        }
    }

    @keyframes slideInLeft {
        from {
            transform: translate3d(-100%, 0, 0);
            visibility: visible;
        }
        to {
            transform: translate3d(0, 0, 0);
        }
    }

    @keyframes slideOutLeft {
        from {
            transform: translate3d(0, 0, 0);
        }
        to {
            visibility: hidden;
            transform: translate3d(-100%, 0, 0);
        }
    }

    @keyframes slideInRight {
        from {
            transform: translate3d(100%, 0, 0);
            visibility: visible;
        }
        to {
            transform: translate3d(0, 0, 0);
        }
    }

    @keyframes slideOutRight {
        from {
            transform: translate3d(0, 0, 0);
        }
        to {
            visibility: hidden;
            transform: translate3d(100%, 0, 0);
        }
    }

    @keyframes slideInUp {
        from {
            transform: translate3d(0, 100%, 0);
            visibility: visible;
        }
        to {
            transform: translate3d(0, 0, 0);
        }
    }

    @keyframes slideOutUp {
        from {
            transform: translate3d(0, 0, 0);
        }
        to {
            visibility: hidden;
            transform: translate3d(0, -100%, 0);
        }
    }

    .slide-enter-active,
    .slideIn,
    .slide-leave-active,
    .slideOut {
        animation-duration: 1s;
        animation-fill-mode: both;
    }

    .slide-enter-active,
    .slideIn {
        animation-name: slideIn;
    }

    .slide-leave-active,
    .slideOut {
        animation-name: slideOut;
    }

    .slideUp-enter-active,
    .slideInUp,
    .slideUp-leave-active,
    .slideOutUp {
        animation-duration: 1s;
        animation-fill-mode: both;
    }

    .slideUp-enter-active,
    .slideInUp {
        animation-name: slideInUp;
    }

    .slideUp-leave-active,
    .slideOutUp {
        animation-name: slideOutUp;
    }

    .slideRight-enter-active,
    .slideInRight,
    .slideRight-leave-active,
    .slideOutRight {
        animation-duration: 1s;
        animation-fill-mode: both;
    }

    .slideRight-enter-active,
    .slideInRight {
        animation-name: slideInRight;
    }

    .slideRight-leave-active,
    .slideOutRight {
        animation-name: slideOutLeft;
    }

    .slideLeft-enter-active,
    .slideInLeft,
    .slideLeft-leave-active,
    .slideOutLeft {
        animation-duration: 1s;
        animation-fill-mode: both;
    }

    .slideLeft-enter-active,
    .slideInLeft {
        animation-name: slideInLeft;
    }

    .slideLeft-leave-active,
    .slideOutLeft {
        animation-name: slideOutRight;
    }

    .slideDown-enter-active,
    .slideInDown,
    .slideDown-leave-active,
    .slideOutDown {
        animation-duration: 1s;
        animation-fill-mode: both;
    }

    .slideDown-enter-active,
    .slideInDown {
        animation-name: slideInDown;
    }

    .slideDown-leave-active,
    .slideOutDown {
        animation-name: slideOutDown;
    }

    @keyframes zoomIn {
        from {
            opacity: 0;
            transform: scale3d(0.3, 0.3, 0.3);
        }
        50% {
            opacity: 1;
        }
    }

    @keyframes zoomOut {
        from {
            opacity: 1;
        }
        50% {
            opacity: 0;
            transform: scale3d(0.3, 0.3, 0.3);
        }
        to {
            opacity: 0;
        }
    }

    @keyframes zoomInDown {
        from {
            opacity: 0;
            transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);
            animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
        }
        60% {
            opacity: 1;
            transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);
            animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
        }
    }

    @keyframes zoomOutDown {
        40% {
            opacity: 1;
            transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);
            animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
        }
        to {
            opacity: 0;
            transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 2000px, 0);
            transform-origin: center bottom;
            animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
        }
    }

    @keyframes zoomInLeft {
        from {
            opacity: 0;
            transform: scale3d(0.1, 0.1, 0.1) translate3d(-1000px, 0, 0);
            animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
        }
        60% {
            opacity: 1;
            transform: scale3d(0.475, 0.475, 0.475) translate3d(10px, 0, 0);
            animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
        }
    }

    @keyframes zoomOutLeft {
        40% {
            opacity: 1;
            transform: scale3d(0.475, 0.475, 0.475) translate3d(42px, 0, 0);
        }
        to {
            opacity: 0;
            transform: scale(0.1) translate3d(-2000px, 0, 0);
            transform-origin: left center;
        }
    }

    @keyframes zoomInRight {
        from {
            opacity: 0;
            transform: scale3d(0.1, 0.1, 0.1) translate3d(1000px, 0, 0);
            animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
        }
        60% {
            opacity: 1;
            transform: scale3d(0.475, 0.475, 0.475) translate3d(-10px, 0, 0);
            animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
        }
    }

    @keyframes zoomOutRight {
        40% {
            opacity: 1;
            transform: scale3d(0.475, 0.475, 0.475) translate3d(-42px, 0, 0);
        }
        to {
            opacity: 0;
            transform: scale(0.1) translate3d(2000px, 0, 0);
            transform-origin: right center;
        }
    }

    @keyframes zoomInUp {
        from {
            opacity: 0;
            transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 1000px, 0);
            animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
        }
        60% {
            opacity: 1;
            transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);
            animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
        }
    }

    @keyframes zoomOutUp {
        40% {
            opacity: 1;
            transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);
            animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
        }
        to {
            opacity: 0;
            transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -2000px, 0);
            transform-origin: center bottom;
            animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
        }
    }

    .zoom-enter-active,
    .zoomIn,
    .zoom-leave-active,
    .zoomOut {
        animation-duration: 1s;
        animation-fill-mode: both;
    }

    .zoom-enter-active,
    .zoomIn {
        animation-name: zoomIn;
    }

    .zoom-leave-active,
    .zoomOut {
        animation-name: zoomOut;
    }

    .zoomUp-enter-active,
    .zoomInUp,
    .zoomUp-leave-active,
    .zoomOutUp {
        animation-duration: 1s;
        animation-fill-mode: both;
    }

    .zoomUp-enter-active,
    .zoomInUp {
        animation-name: zoomInUp;
    }

    .zoomUp-leave-active,
    .zoomOutUp {
        animation-name: zoomOutUp;
    }

    .zoomRight-enter-active,
    .zoomInRight,
    .zoomRight-leave-active,
    .zoomOutRight {
        animation-duration: 1s;
        animation-fill-mode: both;
    }

    .zoomRight-enter-active,
    .zoomInRight {
        animation-name: zoomInRight;
    }

    .zoomRight-leave-active,
    .zoomOutRight {
        animation-name: zoomOutRight;
    }

    .zoomLeft-enter-active,
    .zoomInLeft,
    .zoomLeft-leave-active,
    .zoomOutLeft {
        animation-duration: 1s;
        animation-fill-mode: both;
    }

    .zoomLeft-enter-active,
    .zoomInLeft {
        animation-name: zoomInLeft;
    }

    .zoomLeft-leave-active,
    .zoomOutLeft {
        animation-name: zoomOutLeft;
    }

    .zoomDown-enter-active,
    .zoomInDown,
    .zoomDown-leave-active,
    .zoomOutDown {
        animation-duration: 1s;
        animation-fill-mode: both;
    }

    .zoomDown-enter-active,
    .zoomInDown {
        animation-name: zoomInDown;
    }

    .zoomDown-leave-active,
    .zoomOutDown {
        animation-name: zoomOutDown;
    }
    */

</style>
